module.exports = __webpack_public_path__ + "img/p5.81edbdde.png";